export default __webpack_public_path__ + "static/media/react.e310fdba.png";